module.exports = __webpack_public_path__ + "static/media/khanda.169cde0b.svg";